module.exports = __webpack_public_path__ + "static/media/smp_header_med.f2a436c5.png";